import { memoClassNames } from '@/utils';
import { StatsCard, StatsCardProps } from '@/components/stats';
import { Spinner } from '@/components/icons';
import { DashboardIndicatorBlock } from '../dashboard-block';
import { DashboardEntryData } from '../types';
import { useDashboardContext } from '../hooks/use-dashboard-context';
import { UseDashboardIndicatorProps } from '../hooks/use-dashboard-indicator';

const classes = memoClassNames('NumberIndicator', ['root']);

export type NumberIndicatorProps = React.ComponentProps<'div'> &
  UseDashboardIndicatorProps & {
    icon?: StatsCardProps['icon'];
    variant?: StatsCardProps['variant'];
    displayChange?: (
      indicator: DashboardEntryData,
      data: DashboardEntryData[]
    ) => { value: React.ReactNode; trending?: 'up' | 'down' } | null;
  };

export function NumberIndicator({
  className,
  icon,
  displayChange,
  ...others
}: NumberIndicatorProps) {
  const { data } = useDashboardContext();
  return (
    <DashboardIndicatorBlock
      {...others}
      type="number-indicator"
      data-display="number"
      className={`${classes.root} ${className}`}
      render={({ data: record, value, refreshing, ...displayProps }) => {
        const change =
          record && displayChange && displayChange(record, data || []);

        return (
          <StatsCard
            {...displayProps}
            change={change?.value}
            trending={change?.trending}
            value={refreshing ? <Spinner /> : value}
            icon={icon}
          />
        );
      }}
    />
  );
}

NumberIndicator.displayName = 'NumberIndicator';
